import { DropdownAnchor } from '@fiverr-private/dropdown';

export default DropdownAnchor;
